import IconCloseModal from '@components/UI/atoms/icons/IconCloseModal.svg';

import {CreateTicket} from '@components/tickets/components/forms/Create';
import {ImgIconClose, Nav, StyledModal} from '@components/tickets/StyledTicket';
import {Box, Typography, useTheme} from '@mui/material';
import React, {FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

interface ModalTicketProps {
    isModalOpen: boolean;
    closeModal: () => void;
    method: string;
    message: string;
    listDelete: number[];
    item: any;
}

const ModalTicket: FC<ModalTicketProps> = ({
    isModalOpen,
    closeModal,
    method,
    message = '',
    listDelete = [],
    item = {},
}) => {
    // const dispatch = useDispatch();
    const theme = useTheme();
    const {t} = useTranslation();
    const [status, setStatus] = useState('');

    const validateStatus = () => {
        switch (status) {
            case 'create':
                return <CreateTicket closeModal={closeModal} />;
        }
    };
    useEffect(() => {
        switch (method) {
            case 'Nueva':
                setStatus('create');

                break;

            case 'Modificada':
                setStatus('modified');
                break;
            case 'Error':
                setStatus('warning');
                break;
            default:
                return;
        }
    }, [method]);

    return (
        <StyledModal open={isModalOpen} onClose={closeModal}>
            <Box
                sx={{
                    background: '#EBF0F2',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '3px',
                    width: 'auto',
                    maxWidth: '740px',

                    zIndex: '100',
                }}
            >
                <Nav sx={{justifyContent: 'space-between'}}>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontFamily: theme.typography.fontFamily,
                            fontWeight: 700,
                            color: 'white',
                            paddingLeft: '15px',
                        }}
                    >
                        {method === 'Modificada' || method === 'Error'
                            ? ''
                            : method === 'Nueva'
                            ? t('ticket.add_request')
                            : `${method} ${t('ticket.request')}`}
                    </Typography>
                    <ImgIconClose
                        src={IconCloseModal}
                        onClick={closeModal}
                        sx={{paddingRight: '15px'}}
                    />
                </Nav>
                {validateStatus()}
            </Box>
        </StyledModal>
    );
};

export default ModalTicket;
